import { defineOutOfPageSlot, problemSlot, problemSlotFunc } from './TargetingCheck';
import { bannerShow, bannerHide } from 'shared/actions/globals';

export default ({ googletag, componentWillUnmount }) => {
  if (typeof googletag.pubads !== 'function') {
    return console.error('componentWillUnmount not googletag function');
  }

  if (typeof window === 'object') {
    componentWillUnmount.map(({ dfpNetworkId, adUnit, sizes, slotId, targetingArguments }) => {
      if (window.AbStor && window.AbStor.keyTarget && window.AbStor.keyTarget[slotId]) {
        window.AbStor.keyTarget[slotId] = false;
      }
      switch (slotId) {
        case defineOutOfPageSlot.ab_mobile_web_catfish:
          problemSlotFunc();
          break;
        case problemSlot.ab_branding_top:
          window.document.querySelectorAll('body')[0].style.background = '';
          break;
        default:
          break;
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/shared/modules/googletag/GoogletagUnmount.js